/**
 * @generated SignedSource<<d75c15df11b7fffccda75a2bf559e98b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CertificateVariables = "Category" | "Certifier" | "City" | "Company" | "ContainerCode" | "ContainerCodeFrom" | "ContainerCodeTo" | "Country" | "ExpireDate" | "ExportDate" | "FachberaterSalutation" | "FirstName" | "GraphName" | "IssuanceDate" | "LastName" | "Location" | "NotMapped" | "OneKeyId" | "PersonalPronoun" | "PointsAwarded" | "PostalCode" | "PrepositionTo" | "RecipientLocation" | "RecipientName" | "RecipientSalutation" | "Salutation" | "SalutationDativ" | "SalutationWithNameForDivers" | "SignatureFileUrl" | "Street" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EditCertificateTemplateScreen_CertificateTemplateFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly templateFileRef: string;
  readonly variableMappings: ReadonlyArray<{
    readonly certificateVariable: CertificateVariables;
    readonly templateVariable: string;
  }>;
  readonly " $fragmentType": "EditCertificateTemplateScreen_CertificateTemplateFragment";
};
export type EditCertificateTemplateScreen_CertificateTemplateFragment$key = {
  readonly " $data"?: EditCertificateTemplateScreen_CertificateTemplateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditCertificateTemplateScreen_CertificateTemplateFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditCertificateTemplateScreen_CertificateTemplateFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateFileRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableMapping",
      "kind": "LinkedField",
      "name": "variableMappings",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "certificateVariable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateVariable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CertificateTemplate",
  "abstractKey": null
};

(node as any).hash = "f85c68ee0015e9aa090d09e925cff131";

export default node;
